<ng-template #loadingTemplate>
    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
</ng-template>
<ef-invoice-setup-filters-presenter
    *ngIf="contractsSelectItems$ | async; else loadingTemplate"
    [contracts]="contractsSelectItems$ | async"
    (SelectContract)="onSelectContract($event)"
></ef-invoice-setup-filters-presenter>
